import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class DeliveryProcessService {
  constructor(private http: HttpClientService) {}

  public getDeliveryProcess(application_id): Observable<any> {
    const options = {
      params: { application_id: application_id },
    };
    return this.http
      .get("/api/delivery_process/by_application_id", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcess: Ok.")));
  }

  getDeliveryProcesses({ id = undefined, application_id = undefined, person_id = undefined }): Observable<any> {
    const options = {
      params: { id, application_id, person_id },
    };
    return this.http
      .get("/api/delivery_process", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcessesFromApplication: Ok")));
  }

  getDeliveryProcessesByDeliveryCarUpdate({
    start_date,
    end_date,
    page,
    page_size,
    safeguarding_filter,
    car_delivery_filter,
  }): Observable<any> {
    const options = {
      params: { start_date, end_date, page, page_size, safeguarding_filter, car_delivery_filter },
    };
    return this.http
      .get("/api/delivery_process/by_delivery_car", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcessesByDeliveryCarUpdate: Ok")));
  }

  getDeliveryProcessesBySafeguardingUpdate({
    start_date,
    end_date,
    page,
    page_size,
    delivery_filter,
  }): Observable<any> {
    const options = {
      params: { start_date, end_date, page, page_size, delivery_filter },
    };
    return this.http
      .get("/api/delivery_process/by_safeguard", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcessesBySafeguardingUpdate: Ok")));
  }

  getDeliveryProcessesByDate({ start_date, end_date, page, page_size }): Observable<any> {
    const options = {
      params: { start_date, end_date, page, page_size },
    };
    return this.http
      .get("/api/delivery_process/by_date", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcessesByDate: Ok")));
  }
  getDeliveryProcessesByApplication({ page, page_size, ids = undefined, name = undefined }): Observable<any> {
    const options = {
      params: { page, page_size, ids, name },
    };
    return this.http
      .get("/api/delivery_process/by_application", options)
      .pipe(tap((_) => console.log("DeliveryProcessService.getDeliveryProcessesByApplication: Ok")));
  }
}
